<template>
    <div>
        <div class="flex items-center justify-between" :class="compact ? 'mb-0.5' : 'mb-1'">
            <span :class="compact ? 'text-xs font-semibold text-gray-600' : 'text-sm font-semibold text-gray-700'">{{ title }}</span>
            <span :class="compact ? 'text-xs text-gray-400' : 'text-sm text-gray-500'">
                {{ used }} / {{ limit }}
                <span v-if="extraCredits > 0" class="text-emerald-600 font-semibold">(+{{ extraCredits }})</span>
            </span>
        </div>
        <div class="bg-gray-100 rounded-full overflow-hidden" :class="compact ? 'h-1.5' : 'h-2'">
            <div
                class="h-full rounded-full transition-all"
                :class="barColorClass"
                :style="{ width: percentage + '%' }"
            ></div>
        </div>
    </div>
</template>

<script>
import { computed } from 'vue';

export default {
    props: {
        title: { type: String, required: true },
        used: { type: Number, required: true },
        limit: { type: Number, required: true },
        extraCredits: { type: Number, default: 0 },
        compact: { type: Boolean, default: false }
    },
    setup(props) {
        const total = computed(() => props.limit + props.extraCredits);
        const percentage = computed(() => {
            if (!total.value) return 0;
            return Math.min((props.used / total.value) * 100, 100);
        });
        const barColorClass = computed(() => {
            if (percentage.value >= 100) return 'bg-red-500';
            if (percentage.value >= 80) return 'bg-orange-400';
            return 'bg-emerald-500';
        });

        return { percentage, barColorClass };
    }
};
</script>
